import { render, staticRenderFns } from "./OsusumeCategory.vue?vue&type=template&id=79459454&"
import script from "./OsusumeCategory.vue?vue&type=script&lang=ts&"
export * from "./OsusumeCategory.vue?vue&type=script&lang=ts&"
import style0 from "./OsusumeCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OsusumeCategory.vue"
export default component.exports